import { processShapeImg } from '@/assets/imgs'
import Image, { StaticImageData } from 'next/image'

type Props = {
  img: string | StaticImageData
  title: string
}

const SingleProcess = ({ img, title }: Props) => {
  return (
    <div className='relative flex flex-col items-center gap-16'>
      <Image alt='process shape' src={processShapeImg} className='absolute' />
      <Image alt='process' src={img} />
      <h3 className='text-2xl font-bold'>{title}</h3>
    </div>
  )
}

export default SingleProcess
